<form [formGroup]="form1" (ngSubmit)="create()" *ngIf="(driver?.id>0&& carsId>0) else notStore">
    <div class="card">
      <div class="card-header text-center" style="text-transform: uppercase">
        VALIDAR DATOS
      </div>
      <div class="card-body">
        <div class="row gx-3 mb-3">
          <div class="col-sm-12">
            <label class="small mb-1" for="name">Nombre y Apellidos</label>
            <div class="input-group">
              <input type="text" class="form-control text-capitalize" formControlName="name" uppercaseInput />
            </div>
          </div>
          <div class="col-md-12">
            <label class="small mb-1" for="rut">RUT/IDENTIFICACIÓN</label>
            <div class="input-group">
              <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-id-card"></i></span>
              <input type="text" class="form-control" formControlName="rut" uppercaseInput />
            </div>
          </div>
        </div>
        <button class="btn btn-primary w-100" type="submit">AGREGAR</button>
      </div>
    </div>
  </form>
  <ng-template #notStore>
    <h2>No se recibio el identificador, que se debe asociar</h2>
  </ng-template>